/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.addons.controllers', [
  'colorpicker.module',
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.factory.gridState'
])

.controller('PosCreatePagesFormsAddonsController', ['$scope', '$timeout', '$filter', 'ApiService', 'PosConfigService', 'GridStateFactory', function($scope, $timeout, $filter, ApiService, PosConfigService, GridStateFactory) {

    $scope.posCreatePagesFormsAddons = {

      queryTimer: false,

      model: [],
      list: [],

      title: '',
      subTitle: '',
      color: '',
      selected: '',
      showIcon: false,
      reduceList: false,
      isLoaded: false,
      colorCodes: {
        textColor: '',
        backgroundColor: ''
      },

      spectrumConfig: {
        titleText: 'Tile color'
      },
      gridState: new GridStateFactory(),

      pageSize: 20,

      lastSearchQuery: '',
      totalServerItems: 1,
      currentAddon: false,

      init: function() {
        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);

        $scope.$watch('posCreatePagesFormsAddons.selected', this.onSelected);

        $scope.$watchCollection('posCreatePagesFormsAddons.colorCodes', this.onColorCodesUpdate);

        $scope.$on('destroy', function() {
          $timeout.cancel($scope.posCreatePagesFormsAddons.queryTimer);
        });
      },
      
      getAddons: function (searchQuery) {

        this.gridState.updateGridState(null, this.pageSize, 'name', 'asc');
        this.gridState.gridState.search = searchQuery || '';

        ApiService.inventory.list(angular.extend({saleChannel: 'pointOfSale', addonTypes: 'doNotTrack,membershipCardReplacement'}, this.gridState.getGridState())).then(this.success.getAddons, this.error.getAddons);
      },

      getAddon: function(id) {
        ApiService.inventory.detail(id).then(this.success.getAddon, this.error.getAddon);
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      hasSelected: function() {
        return (this.selected && typeof this.selected === 'object');
      },

      findAddon: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.list.length;i<ii;i++) {
          if (""+this.list[i].id === ""+id) {
            r = {
              addon: this.list[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      getTitle: function() {
        var r = 'Enter a title';
        if (this.selected && this.selected.name) {
          r = this.selected.name;
        }

        return r;
      },

      process: function (addons, count) {
        var r = addons,
            currentCount = (this.gridState.gridState.page || 1) * this.gridState.gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMore = {
            showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this.showMore = {
            showMoreLabel: '',
            hasMore: false
          };
        }

        return r;
      },

      remove: function() {
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', this.model);
      },

      cancel: function() {
        $scope.$emit('PosCreatePagesFormsController::Cancel', this.model);
      },

      resetAddOn: function() {
        var foundAddon, self = $scope.posCreatePagesFormsAddons;
        $timeout(function() {
          //reset addon selected if no addon is chosen
          if (!self.hasSelected()) {
            foundAddon = self.findAddon(self.model.id);

            if (foundAddon || self.currentAddon) {
              self.selected = !foundAddon ? self.currentAddon : self.list[foundAddon.index];
            }
          }
          this.reduceList = false;
        },0);
      },

      search: function(field) {
        this.searching = true;
        ApiService.inventory.list(angular.extend({saleChannel: 'pointOfSale'}, this.gridState.getGridState())).then(function(response) {
          $scope.posCreatePagesFormsAddons.success.search(response, field);
        }, this.error.search);
      },

      filterList: function(force, field) {

        var timeoutMS = force ? 0 : 500;

        if (this.queryTimer) {
          $timeout.cancel(this.queryTimer);
        }

        this.queryTimer = $timeout(function () {
          var self = $scope.posCreatePagesFormsAddons;

          if (force || (typeof self.selected === 'string') && (self.lastSearchQuery !== self.selected)) {
            if (!force) {
              self.gridState.setPropertyValue('pageSize', self.pageSize);
            } else {
              self.gridState.setPropertyValue('pageSize', (self.gridState.gridState.pageSize + self.pageSize) );
            }
            self.gridState.gridState.search = self.hasSelected() ? '' : self.selected;
            self.lastSearchQuery = self.gridState.gridState.search;
            self.search(field);
          }
        }, timeoutMS);
      },

      showMoreResults: function(item) {
        switch(item.field) {
          case 'pos-create-pages-forms-addons-list': this.filterList(true, item.field);
            break;
        }
      },

      done: function () {
        this.model.name = '';

        if (this.title) {
          this.model.name = this.title;
        } else if (this.selected && this.selected.name) {
          this.model.name = this.selected.name;
        }

        if (this.selected) {
          this.model.id = this.selected.id;
        }

        this.model.icon = (this.showIcon) ? 'addon' : 'none';

        this.model.subTitle = this.subTitle;
        this.model.color = PosConfigService.tiles.toColor(this.color);
        if (!this.model.color.a) {
          this.model.color.a = 1;
        }
        this.model.type = 'addon';
        if (this.selected.price) {
          this.model.price = this.selected.price;
        }

        if (this.model.config.pageId) {
          this.model.config.pageId = null;
          delete this.model.config.pageId;
        }

        PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), this.model);
        $scope.$emit('PosCreatePagesFormsController::UpdateTile');
      },

      success: {
        init: function(response) {},
        
        getAddons: function (response) {
          var self = $scope.posCreatePagesFormsAddons;

          self.totalServerItems = response.data.payload.pagination.count;

          self.list = self.process(response.data.payload.list, self.totalServerItems);

          self.isLoaded = true;
        },

        getAddon: function (response) {
          var self = $scope.posCreatePagesFormsAddons;

          self.currentAddon = response.data.payload;

          self.selected = self.currentAddon;
          self.title = (self.model.name !== self.currentAddon.name) ? self.model.name : '';

          //only fetch the initial list once.
          self.getAddons();
        },

        search: function(response, field) {
          var self = $scope.posCreatePagesFormsAddons;

          self.list = self.process(response.data.payload.list, response.data.payload.pagination.count);

          if (field) {
            $scope.$broadcast('CustomTypeahead::FilterResults', {field: field});
          }

        }
      },

      error: {
        init: function(response) {},
        getAddons: function (response) {
          var self = $scope.posCreatePagesFormsAddons;
          self.totalServerItems = 0;
          self.list = [];
          self.isLoaded = true;
        },

        getAddon: function (response) {
          var self = $scope.posCreatePagesFormsAddons;
          self.currentAddon = false;
        },

        search: function(response, field) {
          var self = $scope.posCreatePagesFormsAddons;
          self.list = [];
        }
      },

      onSelected: function(n, o) {
        var self = $scope.posCreatePagesFormsAddons;

        if (self.hasSelected() && self.model.id == self.selected.id) {
          if (self.model.name && self.model.name.length) {
            self.title = (self.model.name !== self.selected.name) ? self.model.name : '';
          }else{
            self.title = '';
          }
          self.subTitle = self.model.subTitle;
        }else {
          self.title = '';
          self.subTitle = '';
        }
      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {
        var foundAddon,
            self = $scope.posCreatePagesFormsAddons;

        if (data.config.type === 'addon') {
          self.selected = '';

          self.model = data;
          // Force watcher change event by resetting color to black
          self.spectrumConfig.color = '#000000';
          self.color = PosConfigService.tiles.toHex(PosConfigService.tiles.colorToRgb(self.model));
          // next tick
          $timeout(function() {
            self.spectrumConfig.color = self.color;
          }, 0);

          self.showIcon = (self.model.icon && self.model.icon !== 'none');

          if (self.model.id) {
            if (self.currentAddon.id !== self.model.id) {
              self.getAddon(self.model.id);
            } else {
              self.selected = self.currentAddon;
              self.title = (self.model.name !== self.currentAddon.name) ? self.model.name : '';
            }
          } else {
            self.currentAddon = false;
            self.getAddons();
          }
        }
      },

      onColorCodesUpdate: function(n, o) {
        if (n && n !== o) {
          $scope.posCreatePagesFormsAddons.color = n.backgroundColor;
        }
      }

    };

    $scope.posCreatePagesFormsAddons.init();

}]);